module.exports = __webpack_public_path__ + "img/dropped-image-3.8c53d2d5.png";